
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"125","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2218"}},[_c('path',{attrs:{"data-name":"Rectangle 2938","fill":"none","d":"M0 0h124.999v120H0z"}}),_c('path',{attrs:{"data-name":"Path 1349","d":"M124.999 78.026l-1.156-1.157a11.578 11.578 0 00-3-5.2l-50.5-50.5a4 4 0 00-5.656 5.656 3.674 3.674 0 010 5.184 3.971 3.971 0 00-.918 1.453L51.476 21.169a4 4 0 00-5.656 5.656 3.674 3.674 0 010 5.184 3.96 3.96 0 00-.916 1.449l-12.29-12.289a4 4 0 00-5.657 5.656 3.672 3.672 0 010 5.184 4 4 0 000 5.656l7.411 7.41h-9.372a4 4 0 00-4 4v22.426a28.406 28.406 0 008.613 20.384l28.112 28.112h67.275z","fill":"#ec4618"}}),_c('g',{attrs:{"data-name":"Group 2217","fill":"#f9a36c"}},[_c('path',{attrs:{"data-name":"Path 1350","d":"M85.785 45.078H24.999a4 4 0 00-4 4v22.426a28.476 28.476 0 0056.672 4.008h8.114a15.217 15.217 0 000-30.434zm0 22.434h-7.8V53.078h7.8a7.217 7.217 0 010 14.434z"}}),_c('path',{attrs:{"data-name":"Path 1351","d":"M26.96 37.667a4 4 0 005.657 0 11.679 11.679 0 000-16.5 4 4 0 00-5.657 5.656 3.672 3.672 0 010 5.184 4 4 0 000 5.66z"}}),_c('path',{attrs:{"data-name":"Path 1352","d":"M45.82 37.667a4.008 4.008 0 005.66 0 11.67 11.67 0 000-16.5 4.002 4.002 0 10-5.656 5.664 3.655 3.655 0 010 5.176 4.006 4.006 0 00-.004 5.66z"}}),_c('path',{attrs:{"data-name":"Path 1353","d":"M64.687 37.667a4.008 4.008 0 005.66 0 11.67 11.67 0 000-16.5 4.002 4.002 0 00-5.656 5.664 3.655 3.655 0 010 5.176 4.006 4.006 0 00-.004 5.66z"}})])])])
          )
        }
      }
    